import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import WorkspaceService from "@core-ui/ContextServices/Workspace";

/** GES or GES Cloud: the share action copies the link without the token warning, as `buildCatalogMenu` does for the catalog. */
export const useIsAnyGes = (): boolean => {
	const { enterpriseCloud } = PageDataContextService.value.conf;
	const hasWorkspaceGesUrl = !!WorkspaceService.current()?.enterprise?.gesUrl;
	return hasWorkspaceGesUrl || (!!enterpriseCloud.url && enterpriseCloud.enabled);
};
